import { ReactElement } from "react";
import { useParams } from "react-router";
import useWebSocket from "react-use-websocket";
import RfqContext from "./RfqContext";
import { handleWsTransId } from "./resolveTransactions";
import { components } from "../ApiSchema";

export function WebsocketRfqProvider({ children }: { children: ReactElement }) {
  const { teamSlug, rfqId } = useParams();
  const wsUrl = `wss://${window.location.host}/api/teams/${teamSlug}/rfqs/${rfqId}/stream`;

  const { lastJsonMessage } = useWebSocket<
    WsErrorMessageSchema | WsRfqDataMessageSchema
  >(
    wsUrl,
    {
      shouldReconnect: () => true,
      filter: (message) => {
        try {
          const json: WsErrorMessageSchema | WsRfqDataMessageSchema =
            JSON.parse(message.data);
          return json.type === "rfq";
        } catch {
          return false;
        }
      },
      onMessage: (message) => {
        const json: WsErrorMessageSchema | WsRfqDataMessageSchema = JSON.parse(
          message.data,
        );
        if (json.type === "rfq") {
          handleWsTransId(json.last_transaction_id);
        }
      },
    },
    !!rfqId,
  );

  const data = (lastJsonMessage as WsRfqDataMessageSchema | null)?.data ?? null;

  return <RfqContext.Provider value={data}>{children}</RfqContext.Provider>;
}

type WsErrorMessageSchema = components["schemas"]["WsErrorMessageSchema"];
type WsRfqDataMessageSchema = components["schemas"]["WsRfqDataMessageSchema"];
